import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { Icon } from '@iconify/react';

const PaymentUrlModal = ({ show, onClose, paymentUrl }) => {
    if (!show) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(paymentUrl);
        toast.success('Copied to clipboard!');
    };

    const handleShare = (platform) => {

        const message = encodeURIComponent("Here is your payment link:");

        let shareUrl = '';
        if (platform === 'whatsapp') {
            shareUrl = `https://wa.me/?text=${message}%20${paymentUrl}`;
        } else if (platform === 'email') {
            shareUrl = `mailto:?subject=Payment%20Link&body=${message}%20${paymentUrl}`;
        }

        window.open(shareUrl, '_blank');
    };

    return (
        <motion.div
            className="modal fade show"
            tabIndex="-1"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            style={{
                display: 'block',
                backgroundColor: 'rgba(0,0,0,0.6)',
                backdropFilter: 'blur(6px)',
                zIndex: 1050,
            }}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{
                    borderRadius: '16px',
                    border: 'none',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                }}>
                    <div className="modal-header border-bottom-0 pb-0">
                        <h6 className="modal-title fw-bold">Share Payment URL</h6>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body pt-2">
                        <label className="form-label fw-semibold">Copy and share this secure link:</label>
                        <div className="input-group mb-3 shadow-sm">
                            <input
                                type="text"
                                className="form-control"
                                value={paymentUrl}
                                readOnly
                                style={{ borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleCopy}
                                style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px' }}
                            >
                                Copy
                            </button>
                        </div>

                        <div className="d-flex flex-wrap gap-2 mt-4">
                            <button
                                className="btn btn-outline-success flex-grow-1 d-flex align-items-center justify-content-center gap-2"
                                onClick={() => handleShare('whatsapp')}
                            >
                                <Icon icon="ic:baseline-whatsapp" width="20" height="20" />
                                <span>Share via WhatsApp</span>
                            </button>

                            <button
                                className="btn btn-outline-secondary flex-grow-1 d-flex align-items-center justify-content-center gap-2"
                                onClick={() => handleShare('email')}
                            >
                                <Icon icon="ic:outline-email" width="20" height="20" />
                                <span>Share via Email</span>
                            </button>
                        </div>

                    </div>

                    <div className="modal-footer border-top-0">
                        <button
                            type="button"
                            className="btn btn-primary w-100"
                            onClick={onClose}
                            style={{ borderRadius: '8px' }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default PaymentUrlModal;
